<template>
  <div class="perfil-geral meus-cadernos" id="cadernos">
    <div class="d-flex align-items-center mb-4">
      <h2>Meus cadernos</h2>
      <span class="barra-tit flex-fill"></span>
    </div>

    <div class="filtros">
      <p>Filtros</p>
      <div class="row">
        <div class="col-12 col-md-6">
          <label>Categoria</label>
          <b-form-select v-model="filtroCadernos.categoria" id="cadernoCategoria" :options="categorias" value-field="id" text-field="title" label="" @change="filtrarCadernos">
            <template slot="first">
              <option value="">Selecione</option>
            </template>
          </b-form-select>
        </div>
        <div class="col-12 col-md-3">
          <label>Data inicial</label>
          <input type="text" class="form-control" placeholder="DD/MM/AAAA" v-mask="'##/##/####'" v-model="filtroCadernos.dataInicial" @change="filtrarCadernos"/>
        </div>
        <div class="col-12 col-md-3">
          <label>Data final</label>
          <input type="text" class="form-control" placeholder="DD/MM/AAAA" v-mask="'##/##/####'" v-model="filtroCadernos.dataFinal" @change="filtrarCadernos"/>
        </div>
      </div>
    </div>

    <div class="row mt-4" v-if="cursos && cursos.length">
      <caderno-curso-collapse v-for="(curso, index) in cursos" :key="'cadernos-curso-' + index" :curso="curso" @cadernoEscolhidoChange="handleCadernoEscolhidoChange" />
    </div>
    <div class="row mt-4" v-else>
      <div class="col-12 col-md">
        Nenhum caderno encontrado.
      </div>
    </div>

    <modal-caderno :licao="licaoEscolhida" />

  </div>
</template>

<script>
import ModalCaderno from '@/core/components/ModalCaderno'
import CategoriaAPI from '@/api/categorias-api'
import PerfilAPI from '@/api/perfil-api'
import { mask } from 'vue-the-mask'
import CadernoCursoCollapse from '@/modules/Perfil/components/meus-cadernos/CadernoCursoCollapse'
import DateUtils, { DateConstants } from '@/core/utils/date-utils'

export default {
  name: 'MeusCadernosPerfil',
  components: { CadernoCursoCollapse, ModalCaderno },
  directives: { mask },
  data () {
    return {
      categorias: [],
      filtroCadernos: {
        categoria: '',
        dataInicial: '',
        dataFinal: ''
      },
      cursos: [],
      licaoEscolhida: { }
    }
  },

  mounted () {
    CategoriaAPI.listarCategorias().then(data => {
      this.categorias = data.categorias
    })

    this.listarCadernos()
  },

  methods: {
    handleCadernoEscolhidoChange: function (licao) {
      this.licaoEscolhida = licao
    },

    filtrarCadernos: function () {
      const dataInicio = this.filtroCadernos.dataInicial ? DateUtils.formatDate(DateUtils.parse(this.filtroCadernos.dataInicial, DateConstants.DD_MM_YYYY)) : null
      const dataFim = this.filtroCadernos.dataFinal ? DateUtils.formatDate(DateUtils.parse(this.filtroCadernos.dataFinal, DateConstants.DD_MM_YYYY)) : null

      this.listarCadernos(this.filtroCadernos.categoria, dataInicio, dataFim)
    },

    listarCadernos: function (idCategoria, dataInicio, dataFim) {
      const loader = this.$loading.show()

      PerfilAPI.listarMeusCadernos(idCategoria, dataInicio, dataFim).then(data => {
        // TODO Atencao aqui! Essa api pode mudar pois o response dela esta retornando tanto as categorias, quanto os cadernos.
        if (data.length > 1) {
          this.cursos = data[1]
        }
      }).then(() => loader.hide())
    }
  }
}
</script>

<style scoped>

</style>
